// common business logic related util methods
import axios from "axios";
import { baseUri } from "../config/config";

axios.defaults.headers.post["Content-Type"] = "application/json";

/** Join base + path without creating `//` (except after protocol). */
const joinUrl = (base, path) => {
  const b = String(base || "");
  let p = String(path || "");
  if (b.endsWith("/") && p.startsWith("/")) {
    p = p.slice(1);
  } else if (
    b &&
    !b.endsWith("/") &&
    p &&
    !p.startsWith("/") &&
    !p.startsWith("?")
  ) {
    return `${b}/${p}`;
  }
  return b + p;
};

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  const reqObj = {
    method,
    url: joinUrl(baseUri, path),
    headers,
  };

  reqObj.params = queryParams;

  if (method === "POST") {
    reqObj.data = postData;
  }
  if (method === "PUT") {
    reqObj.data = postData;
  }
  if (method === "DELETE") {
    reqObj.data = postData;
  }

  let results;
  if (postData instanceof FormData) {
    console.info(...postData, "<===REQUEST-DATA===>");
  }
  console.info("<===REQUEST-OBJECT===>", reqObj);

  try {
    results = await axios(reqObj);
    console.info("<===Api-Success-Result===>", results);

    return results.data;
  } catch (error) {
    console.info("<===Api-Error===>", error.response?.data);

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return {
      code: error.response?.status,
      message: error.response?.data?.message ? error.response.data.message : "",
    };
  }
}
